module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"agarre":"Agarre","regularizacion":"Regularización","soporte_antes":"Se debe seleccionar el tipo de soporte del escenario antes","soporte_agarr_antes":"Se debe seleccionar el tipo de soporte del escenario y el agarre antes","agarr_antes":"Se debe seleccionar el material de agarre antes"}}')
  delete Component.options._Ctor
}
